import { 
	canAccess,
	ifAuthenticated, 
	ifNotAuthenticated, 
	ifAuthenticatedOnline, 
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'
import EdocumentsIndex from '@/components/modules/invoices/edocuments/EdocumentsIndex'

// Tipi di documento che generano scadenze e il crud scadenze corrispondente
// (lato cliente o lato fornitore, come le tab Scadenze di azienda/fornitore)
const COMPANY_SIDE = { modelDef: 'companydeadlines', model: 'companydeadline', paymentsModelDef: 'companypayments', paymentsModel: 'companypayment' }
const SUPPLIER_SIDE = { modelDef: 'supplierdeadlines', model: 'supplierdeadline', paymentsModelDef: 'supplierpayments', paymentsModel: 'supplierpayment' }
const DOCUMENT_DEADLINES = {
	saleinvoices: COMPANY_SIDE,
	creditnotes: COMPANY_SIDE,
	debitnotes: COMPANY_SIDE,
	purchaseinvoices: SUPPLIER_SIDE,
	suppliercreditnotes: SUPPLIER_SIDE,
}
const documentDeadlines = (doctype) => DOCUMENT_DEADLINES[doctype] || null

// Percorsi al singolare delle vecchie show senza tab: il percorso generico
// /invoices/:doctype/:id/ li intercetta prima delle rotte dedicate, quindi il
// rinvio alla show con le tab va fatto qui
const SINGULAR_DOCTYPES = {
	saleinvoice: 'saleinvoices',
	purchaseinvoice: 'purchaseinvoices',
	creditnote: 'creditnotes',
	debitnote: 'debitnotes',
	suppliercreditnote: 'suppliercreditnotes',
}
const redirectSingularDoctype = (to, from, next) => {
	if (SINGULAR_DOCTYPES[to.params.doctype]) {
		return next({ path: '/invoices/' + SINGULAR_DOCTYPES[to.params.doctype] + '/' + to.params.id + '/', query: to.query, replace: true })
	}
	return ifAuthenticatedOnline(to, from, next)
}

import SendMail from '@/components/common/SendMail'
import PrepareShipment from '@/components/common/PrepareShipment'
import EdocumentImportWizard from '@/components/modules/invoices/edocuments/EdocumentImportWizard'
import EdocumentSelfinvoiceWizard from '@/components/modules/invoices/edocuments/EdocumentSelfinvoiceWizard'
import EdocumentStatistics from '@/components/modules/invoices/edocuments/EdocumentStatistics'
import EInvoiceSettings from '@/components/modules/invoices/settings/EInvoiceSettings'
import CreditnotesSettings from '@/components/modules/invoices/settings/CreditnotesSettings'
import SaleinvoicesSettings from '@/components/modules/invoices/settings/SaleinvoicesSettings'
import PurchaseinvoicesSettings from '@/components/modules/invoices/settings/PurchaseinvoicesSettings'
import ProformainvoicesSettings from '@/components/modules/invoices/settings/ProformainvoicesSettings'
import SelfinvoicesSettings from '@/components/modules/invoices/settings/SelfinvoicesSettings'
import SuppliercreditnotesSettings from '@/components/modules/invoices/settings/SuppliercreditnotesSettings'

export const documents = [
	{
		path: '/proformainvoices',
		redirect: '/invoices/proformainvoices'
	},
	{
		path: '/purchaseinvoices',
		redirect: '/invoices/purchaseinvoices'
	},
	{
		path: '/selfinvoices',
		redirect: '/invoices/selfinvoices'
	},
	{
		path: '/creditnotes',
		redirect: '/invoices/creditnotes'
	},
	{
		path: '/debitnotes',
		redirect: '/invoices/debitnotes'
	},
	{
		path: '/suppliercreditnotes',
		redirect: '/invoices/suppliercreditnotes'
	},
	{
		path: '/edocuments',
		redirect: '/invoices/edocuments'
	},
	{
		path: '/invoices/', 
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/invoices',
					text: trans('saleinvoice'),
					model: 'saleinvoice'
				},
				{
					to: '/invoices/proformainvoices',
					text: trans('proformainvoices'),
					model: 'proformainvoice'
				},
				{
					to: '/invoices/purchaseinvoices',
					text: trans('purchaseinvoices'),
					model: 'purchaseinvoice'
				},
				{
					to: '/invoices/creditnotes',
					text: trans('creditnotes'),
					model: 'creditnote'
				},
				{
					to: '/invoices/debitnotes',
					text: trans('debitnotes'),
					model: 'debitnote'
				},
				{
					to: '/invoices/suppliercreditnotes',
					text: trans('suppliercreditnotes'),
					model: 'suppliercreditnote'
				},
				{
					to: '/invoices/selfinvoices',
					text: trans('selfinvoices'),
					model: 'selfinvoice'
				},
				{
					to: '/invoices/edocuments',
					text: 'Documenti Ricevuti',
					model: 'edocument'
				},
				{
					to: '/invoices/edocuments-statistics',
					text: 'Statistiche Fatturato',
					model: 'edocument'
				},
			]
		}),
		children: [
			{
				path: '/invoices/',
				name: 'documents-saleinvoice-index',
				meta: {
					title: trans('saleinvoice')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: (route) => ({
					modelDef: 'documents-saleinvoice',
					actionIcon: 'description',
					title: trans('saleinvoices'),
					styleClass: 'mb-offset',
					enableNumberingAlert: true
				})
			},
			{
				path: '/invoices/proformainvoices',
				name: 'documents-proformainvoice-index',
				meta: {
					title: trans('proformainvoices')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: (route) => ({
					modelDef: 'documents-proformainvoice',
					actionIcon: 'description',
					title: trans('proformainvoices'),
					styleClass: 'mb-offset',
					enableNumberingAlert: true
				})
			},
			{
				path: '/invoices/purchaseinvoices',
				name: 'documents-purchaseinvoice-index',
				meta: {
					title: trans('purchaseinvoices')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: (route) => ({
					modelDef: 'documents-purchaseinvoice',
					actionIcon: 'description',
					title: trans('purchaseinvoices'),
					styleClass: 'mb-offset',
					enableNumberingAlert: true
				})
			},
			{
				path: '/invoices/creditnotes',
				name: 'documents-creditnote-index',
				meta: {
					title: trans('creditnotes')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: (route) => ({
					modelDef: 'documents-creditnote',
					actionIcon: 'description',
					title: trans('creditnotes'),
					styleClass: 'mb-offset',
					enableNumberingAlert: true
				})
			},
			{
				path: '/invoices/debitnotes',
				name: 'documents-debitnote-index',
				meta: {
					title: trans('debitnotes')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: (route) => ({
					modelDef: 'documents-debitnote',
					actionIcon: 'description',
					title: trans('debitnotes'),
					styleClass: 'mb-offset',
					enableNumberingAlert: true
				})
			},
			{
				path: '/invoices/suppliercreditnotes',
				name: 'documents-suppliercreditnote-index',
				meta: {
					title: trans('suppliercreditnotes')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: (route) => ({
					modelDef: 'documents-suppliercreditnote',
					actionIcon: 'description',
					title: trans('suppliercreditnotes'),
					styleClass: 'mb-offset',
					enableNumberingAlert: true
				})
			},
			{
				path: '/invoices/edocuments',
				name: 'edocument-index',
				meta: {
					title: 'Documenti Ricevuti'
				},
				beforeEnter: ifAuthenticated,
				// Crud + resoconto dell'import massivo aperto dalla notifica
				component: EdocumentsIndex,
				props: (route) => ({
					modelDef: 'edocuments',
					actionIcon: 'description',
					title: 'Documenti Ricevuti',
					styleClass: 'mb-offset'
				})
			},
			{
				path: '/invoices/edocuments-statistics',
				name: 'edocument-statistics',
				meta: {
					title: 'Statistiche Fatturato'
				},
				beforeEnter: ifAuthenticated,
				component: EdocumentStatistics
			},
			{
				path: '/invoices/selfinvoices',
				name: 'documents-selfinvoice-index',
				meta: {
					title: trans('selfinvoices')
				},				
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: (route) => ({
					modelDef: 'documents-selfinvoice',
					actionIcon: 'description',
					title: trans('selfinvoices'),
					styleClass: 'mb-offset',
					enableNumberingAlert: true
				})
			}
		]
	},
	{ 
		path: '/invoices/:doctype/create',
		name: 'documents-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'documents-'+route.params.doctype,
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: {'modelDef': 'documents-show', params: {doctype: route.params.doctype}},
			footerComponent: 'footer-product-document-table'
		}),
	},
	{ 
		path: '/invoices/:doctype/:id/edit',
		name: 'documents-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'documents-'+route.params.doctype,
			id: parseInt(route.params.id),
			disabledUpdateKey: 'closed',
			footerComponent: 'footer-product-document-table',
			redirect: {'modelDef': 'documents-show', params: {doctype: route.params.doctype}}
		}),
	},
	{
		path: '/invoices/edocuments/:id/import',
		name: 'edocument-import',
		beforeEnter: ifAuthenticatedOnline,
		component: EdocumentImportWizard,
		meta: {
			title: 'Importa Documento Elettronico',
		},
		props: (route) => ({
			id: parseInt(route.params.id)
		}),
	},
	{
		path: '/invoices/edocuments/:id/generate-selfinvoice',
		name: 'edocument-generate-selfinvoice',
		beforeEnter: ifAuthenticatedOnline,
		component: EdocumentSelfinvoiceWizard,
		meta: {
			title: 'Genera Autofattura',
		},
		props: (route) => ({
			id: parseInt(route.params.id)
		}),
	},
	{
		path: '/invoices/edocuments/:id/',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/invoices/edocuments/' + parseInt(route.params.id) + '/',
					text: 'Documento Ricevuto',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'edocuments-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Documento',
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'edocuments',
					noEdit: true,
					pdfPreviewUrl: 'edocuments/e-invoice',
					redirect: {'modelDef': 'documents', params: {doctype: route.params.doctype}}
				}),
			},
		]
	},
	{ 
		path: '/invoices/:doctype/:id/',
		beforeEnter: redirectSingularDoctype,
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: /invoices/ + route.params.doctype + '/' + parseInt(route.params.id) + '/',
					text: trans(route.params.doctype),
				},
				// Scadenze generate dal documento: crud scadenze cliente/fornitore
				// filtrato per document_id, solo per i tipi che le producono
				...(documentDeadlines(route.params.doctype) ? [{
					to: '/invoices/' + route.params.doctype + '/' + parseInt(route.params.id) + '/deadlines',
					text: 'Scadenze',
					model: documentDeadlines(route.params.doctype).model,
				}, {
					// pagamenti registrati sulle rate del documento
					to: '/invoices/' + route.params.doctype + '/' + parseInt(route.params.id) + '/payments',
					text: 'Pagamenti',
					model: documentDeadlines(route.params.doctype).paymentsModel,
				}] : []),
			],
		}),
		children: [
			{
				path: '',
				name: 'documents-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Documento',
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'documents-'+route.params.doctype,
					modelClass: route.params.doctype,
					activities: true,
					maillogs: true,
					edocuments: ['saleinvoices', 'creditnotes', 'selfinvoices'].includes(route.params.doctype),
					deadlines: documentDeadlines(route.params.doctype) !== null,
					redirect: {'modelDef': 'documents', params: {doctype: route.params.doctype}}
				}), 
			},
			{
				path: 'deadlines',
				name: 'documents-deadlines',
				beforeEnter: (to, from, next) => {
					const deadlines = documentDeadlines(to.params.doctype)
					if (!deadlines) {
						return next({ path: '/invoices/' + to.params.doctype + '/' + to.params.id + '/' })
					}
					canAccess('permission', deadlines.model, next)
				},
				component: Crud,
				meta: {
					title: 'Scadenze'
				},
				props: (route) => ({
					modelDef: documentDeadlines(route.params.doctype).modelDef,
					actionIcon: 'mdi-currency-eur',
					title: 'Scadenze Documento',
					styleClass: 'mb-offset',
					subFilters: {documents: parseInt(route.params.id)},
					footerComponent: 'CrudFooter'
				})
			},
			{
				path: 'payments',
				name: 'documents-payments',
				beforeEnter: (to, from, next) => {
					const deadlines = documentDeadlines(to.params.doctype)
					if (!deadlines) {
						return next({ path: '/invoices/' + to.params.doctype + '/' + to.params.id + '/' })
					}
					canAccess('permission', deadlines.paymentsModel, next)
				},
				component: Crud,
				meta: {
					title: 'Pagamenti'
				},
				props: (route) => ({
					modelDef: documentDeadlines(route.params.doctype).paymentsModelDef,
					actionIcon: 'mdi-cash-multiple',
					title: 'Pagamenti Documento',
					styleClass: 'mb-offset',
					subFilters: {documents: parseInt(route.params.id)},
					// "Nuovo" parte dal documento: si apre con la sola azienda/fornitore
					// compilata (tutte le sue rate aperte in elenco, non solo quelle del
					// documento, nessuna preselezionata, importo da inserire)
					defaultInput: {document_id: parseInt(route.params.id)},
				})
			},
		]
	},
	{
		path: '/invoices/:doctype-send-mail/:id',
		name: 'documents-send-mail',
		beforeEnter: ifAuthenticatedOnline,
		component: SendMail,
		props: (route) => ({
			id: parseInt(route.params.id),
			title: 'Invio email ' + trans(route.params.doctype),
			model_name: route.params.doctype,
			route: 'documents-'+route.params.doctype,
			redirect: {'modelDef': 'documents', params: {doctype: route.params.doctype}},
		}),
	},
    {
		path: '/documents/:doctype/:id/prepare-shipment',
		name: 'prepare-shipment',
		component: PrepareShipment,
		meta: {
			title: 'Preparazione Spedizione'
		},
		props: (route) => ({
			documentId: parseInt(route.params.id),
			modelDef: route.params.doctype,
		}),
	},
	{
		path: '/settingsinvoices/',
		name: 'settingsdocuments',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsinvoices',
					text: 'Fatture di Vendita',
				},
				{
					to: '/settingsinvoices/proformainvoices',
					text: 'Fatture Proforma',
				},
				{
					to: '/settingsinvoices/purchaseinvoices',
					text: 'Fatture di Acquisto',
				},
				{
					to: '/settingsinvoices/creditnotes',
					text: 'Note di Credito',
				},
				{
					to: '/settingsinvoices/suppliercreditnotes',
					text: 'NdC Fornitore',
				},
				{
					to: '/settingsinvoices/selfinvoices',
					text: 'Autofatture',
				},
				{
					to: '/settingsinvoices/einvoices',
					text: 'Fatturazione Elettronica',
				},
			],
		},
		children: [

			{
				path: '/settingsinvoices/',
				beforeEnter: ifAuthenticatedOnline,
				component: SaleinvoicesSettings,
			},
			{
				path: '/settingsinvoices/proformainvoices',
				beforeEnter: ifAuthenticatedOnline,
				component: ProformainvoicesSettings,		
			},
			{
				path: '/settingsinvoices/purchaseinvoices',
				beforeEnter: ifAuthenticatedOnline,
				component: PurchaseinvoicesSettings,		
			},
			{
				path: '/settingsinvoices/creditnotes',
				beforeEnter: ifAuthenticatedOnline,
				component: CreditnotesSettings,
			},
			{
				path: '/settingsinvoices/suppliercreditnotes',
				beforeEnter: ifAuthenticatedOnline,
				component: SuppliercreditnotesSettings,
			},
			{
				path: '/settingsinvoices/selfinvoices',
				beforeEnter: ifAuthenticatedOnline,
				component: SelfinvoicesSettings,
			},
			{
				path: '/settingsinvoices/einvoices',
				beforeEnter: ifAuthenticatedOnline,
				component: EInvoiceSettings,
			},
		],
	},
	
	{ 
		path: '/settingsinvoices/templates-saleinvoice/create',
		name: 'templates-saleinvoice-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-saleinvoice',
			defaultInput: {type: 'saleinvoice'},			
		}),
	},
	{ 
		path: '/settingsinvoices/templates-saleinvoice/:id/edit',
		name: 'templates-saleinvoice-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-saleinvoice',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'saleinvoice'},
		}), 
	},
	{ 
		path: '/settingsinvoices/templates-saleinvoice/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingsinvoices/templates-saleinvoice/' + parseInt(route.params.id) + '/',
					text: 'Template Fattura Vendita',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-saleinvoice-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Fattura Vendita'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-saleinvoice',
					modelClass:  'template',
					activities: true
				}), 
			},
		]
	},

	{ 
		path: '/settingsinvoices/templates-proformainvoice/create',
		name: 'templates-proformainvoice-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-proformainvoice',
			defaultInput: {type: 'proformainvoice'},			
		}),
	},
	{ 
		path: '/settingsinvoices/templates-proformainvoice/:id/edit',
		name: 'templates-proformainvoice-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-proformainvoice',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'proformainvoice'},
		}), 
	},
	{ 
		path: '/settingsinvoices/templates-proformainvoice/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingsinvoices/templates-proformainvoice/' + parseInt(route.params.id) + '/',
					text: 'Template Fattura Vendita',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-proformainvoice-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Fattura Vendita'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-proformainvoice',
					modelClass:  'template',
					activities: true
				}), 
			},
		]
	},	
	{ 
		path: '/settingsinvoices/templates-purchaseinvoice/create',
		name: 'templates-purchaseinvoice-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-purchaseinvoice',
			defaultInput: {type: 'purchaseinvoice'},			
		}),
	},
	{ 
		path: '/settingsinvoices/templates-purchaseinvoice/:id/edit',
		name: 'templates-purchaseinvoice-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-purchaseinvoice',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'purchaseinvoice'},
		}), 
	},
	{ 
		path: '/settingsinvoices/templates-purchaseinvoice/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingsinvoices/templates-purchaseinvoice/' + parseInt(route.params.id) + '/',
					text: 'Template Fattura Vendita',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-purchaseinvoice-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Fattura Vendita'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-purchaseinvoice',
					modelClass:  'template',
					activities: true
				}), 
			},
		]
	},

	// creditnote template's routes
	{ 
		path: '/settingsdocuments/templates-creditnote/create',
		name: 'templates-creditnote-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-creditnote',
			redirect: route.params.redirect,
			defaultInput: {type: 'creditnote'},			
		}),
	},
	{ 
		path: '/settingsdocuments/templates-creditnote/:id/edit',
		name: 'templates-creditnote-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-creditnote',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'creditnote'},
		}), 
	},
	{ 
		path: '/settingsdocuments/templates-creditnote/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingsdocuments/templates-creditnote/' + parseInt(route.params.id) + '/',
					text: 'Template Fattura Vendita',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-creditnote-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Fattura Vendita'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-creditnote',
					modelClass:  'template',
					activities: true
				}), 
			},
		]
	},

	// selfinvoice template's routes
	{
		path: '/settingsinvoices/templates-selfinvoice/create',
		name: 'templates-selfinvoice-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-selfinvoice',
			defaultInput: {type: 'selfinvoice'},
		}),
	},
	{
		path: '/settingsinvoices/templates-selfinvoice/:id/edit',
		name: 'templates-selfinvoice-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-selfinvoice',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'selfinvoice'},
		}),
	},
	{
		path: '/settingsinvoices/templates-selfinvoice/:id',
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/settingsinvoices/templates-selfinvoice/' + parseInt(route.params.id) + '/',
					text: 'Template Autofattura',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-selfinvoice-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Autofattura'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-selfinvoice',
					modelClass:  'template',
					activities: true
				}),
			},
		]
	},

	// Le vecchie show senza tab (percorso al singolare, raggiunte da ricerca
	// globale e link dei crud) portano alla show con le tab Scadenze e
	// Pagamenti: stessa pagina da qualunque punto si arrivi
	{
		path: '/invoices/saleinvoice/:id/',
		name: 'documents-saleinvoice-show',
		redirect: to => '/invoices/saleinvoices/' + to.params.id + '/',
	},
	{
		path: '/invoices/proformainvoice/:id/',
		name: 'documents-proformainvoice-show',
		beforeEnter: ifAuthenticatedOnline,
		component: Show,
		meta: {
			title: 'Fattura Proforma',
		},				
		props: (route) => ({
			id: parseInt(route.params.id),
			modelDef: 'documents-proformainvoice',
			modelClass: 'proformainvoice',
			activities: true,
			maillogs: true,
			redirect: {'modelDef': 'documents', params: {doctype: 'proformainvoice'}}
		}), 
	},
	{
		path: '/invoices/purchaseinvoice/:id/',
		name: 'documents-purchaseinvoice-show',
		redirect: to => '/invoices/purchaseinvoices/' + to.params.id + '/',
	},
	{
		path: '/invoices/creditnote/:id/',
		name: 'documents-creditnote-show',
		redirect: to => '/invoices/creditnotes/' + to.params.id + '/',
	},
	{
		path: '/invoices/debitnote/:id/',
		name: 'documents-debitnote-show',
		redirect: to => '/invoices/debitnotes/' + to.params.id + '/',
	},
	{
		path: '/invoices/suppliercreditnote/:id/',
		name: 'documents-suppliercreditnote-show',
		redirect: to => '/invoices/suppliercreditnotes/' + to.params.id + '/',
	},
]